// extracted by mini-css-extract-plugin
export default {"root":"oR2HG","reaction":"ZB14p","mySelectedReaction":"J0bgh"};